import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import GolferDetailsPage from "./Golferdetailspage";
import PackageCheckoutView from "../components/packages/PackageCheckoutView";

export default function PackageBookingFlow() {
  const location = useLocation();
  const navigate = useNavigate();
  const bookingState = location.state || {};

  const [step, setStep] = useState("golfers");
  const [golfers, setGolfers] = useState(bookingState.golfers || []);
  const [bookingId, setBookingId] = useState(null);

  if (!bookingState.selectedPackage) {
    navigate("/packages", { replace: true });
    return null;
  }

  if (step === "golfers") {
    return (
      <GolferDetailsPage
        numPlayers={bookingState.numPlayers}
        initialGolfers={golfers}
        onNext={(g) => {
          setGolfers(g);
          setStep("checkout");
        }}
        onBack={() => navigate(-1)}
      />
    );
  }

  return (
    <PackageCheckoutView
      selectedCourses={bookingState.selectedCourses}
      selectedAccommodation={bookingState.selectedAccommodation}
      sharingType={bookingState.sharingType}
      numRooms={bookingState.numRooms}
      checkInDate={bookingState.checkInDate}
      checkInTime={bookingState.checkInTime}
      checkOutDate={bookingState.checkOutDate}
      selectedFerry={bookingState.selectedFerry}
      selectedFerryTime={bookingState.selectedFerryTime}
      selectedOutboundFerryTime={bookingState.selectedOutboundFerryTime}
      selectedTransport={bookingState.selectedTransport}
      selectedTransportTime={bookingState.selectedTransportTime}
      selectedOutboundTransport={bookingState.selectedOutboundTransport}
      selectedOutboundTransportTime={bookingState.selectedOutboundTransportTime}
      selectedPackage={bookingState.selectedPackage}
      numPlayers={bookingState.numPlayers}
      roundDates={bookingState.roundDates}
      roundTimes={bookingState.roundTimes}
      startDate={bookingState.startDate}
      endDate={bookingState.endDate}
      golfers={golfers}
      bookingId={bookingId}
      onBookingCreated={setBookingId}
      onEditGolfers={() => setStep("golfers")}
      onConfirm={(confirmationData) => {
        navigate("/booking-confirmation", {
          state: { confirmation: confirmationData },
        });
      }}
      onBack={() => setStep("golfers")}
    />
  );
}

// navigate("/booking-confirmation", { state: { confirmation: confirmationData } });
